import { useMutation, useQuery } from "@tanstack/react-query";
import { SampleSeparationApiService } from "./rialabel.api";

export const useRiaLabelService = (payload: any) => {
    const InsertReprintHistoryMutation = useMutation({
        mutationFn: (payload: any) => SampleSeparationApiService.insertHistory(payload),
    });

        // SELECT ALL SAMPLE SEPARATION QUERY
    const SelectAllQuery = useQuery({
        queryKey: ["sample-separation-SelectAll", payload.studyid, payload.period, payload.timepoint, payload.aliquot, payload.currentpage, payload.pagesize, payload.searchtext],
        queryFn: () => SampleSeparationApiService.selectAll(payload),
        enabled: !!(payload.studyid && payload.period && payload.timepoint && payload.aliquot && (Array.isArray(payload.timepoint) ? payload.timepoint.length > 0 : true) && (Array.isArray(payload.aliquot) ? payload.aliquot.length > 0 : true)),
    });

    // UPDATE CRYOVIAL LABEL MUTATION
    const UpdateCryovialLabelMutation = useMutation({
        mutationFn: (payload: any) => SampleSeparationApiService.updateLabel(payload),
    });


    return {
        InsertReprintHistoryMutation,
        SelectAllQuery,
        UpdateCryovialLabelMutation,
    };
};